import React from 'react';
import PropTypes from 'prop-types';
import LabelledRadio from 'wonderbly-components/lib/LabelledRadio';
import List from 'wonderbly-components/lib/List';

import './AddressList.scss';

const AddressList = props =>
  props.addresses.length > 0 ? (
    <List
      type="bulletless"
      className="address-list"
      items={props.addresses.map((address, index) => (
        <div key={`key-${index}`}>
          <LabelledRadio
            id={`location-${index}`}
            value={index.toString()}
            name="locations"
            onChange={props.onChange}
            checked={props.addressListIndex === index}>
            {address.name}
          </LabelledRadio>
        </div>
      ))}
    />
  ) : (
    <ul className="address-list" />
  );

AddressList.propTypes = {
  addressListIndex: PropTypes.number,
  addresses: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AddressList;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/HomeAddress/AddressList/AddressList.js